import { nextTick } from 'vue'


export const scrollToFirstError = async () => {
    await nextTick();

    const errorElement = document.querySelector(".Form__Element__ValidationError, .validation-error");

    if (errorElement) {
        const elementRect = errorElement.getBoundingClientRect();
        const offset = window.pageYOffset || document.documentElement.scrollTop;

        let viewportOffset = 100;

        if (errorElement.classList.contains("Form__Element__ValidationError")) {
            viewportOffset = 150; 
        }

        const top = elementRect.top + offset - viewportOffset;

        window.scrollTo({
            top,
            behavior: 'smooth',
        });

        if (typeof errorElement.focus === "function") {
            errorElement.setAttribute("tabindex", "-1"); 
            errorElement.focus({ preventScroll: true });
        }
    } else {
        console.warn("No validation error elements found.");
    }
};


